import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-yuanchengkongzhi1",
  "use": "icon-icon-yuanchengkongzhi1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-yuanchengkongzhi1\"><path d=\"M336 776h352v-528h-352v528z m-176-70.4h140.8v-387.2H160v387.2z m563.2-387.2v387.2h140.8v-387.2h-140.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-yuanchengkongzhi1.svg
// module id = YvdQ
// module chunks = 3